// extracted by mini-css-extract-plugin
export default {"button":"ScrollTopButton_button__AEJwd","icon":"ScrollTopButton_icon__pV1cT"};